import { AxiosRequestConfig } from "axios";

import { createApiQueryHook, IPaginateable, mapPagination } from "../../utils/api";
import { serialize } from "../../utils/url";
import { ICurrentBrandList } from "../types/ICurrentBrandList";

export type ICurentBrandListQueryParameters = IPaginateable;

export type ICurentBrandListQueryResult = ICurrentBrandList;

export const currentBrandListQuery = ({ pagination }: ICurentBrandListQueryParameters): AxiosRequestConfig => {
    return {
        method: "GET",
        url: `/current_brands${serialize({ ...mapPagination(pagination) }, true)}`,
    };
};

export const useCurrentBrandListQuery = createApiQueryHook<
    ICurentBrandListQueryParameters,
    ICurentBrandListQueryResult
>(currentBrandListQuery);
